module.exports = __webpack_public_path__ + "static/kadmos-logo-8148c4e63c4e7ad00364aa3863e8b887.png";